export const getPurposeCandidateList = async (candidateId) => {
  try {
    const resp = await fetch(`${process.env.REACT_APP_API}/ta/candidates/purpose/${candidateId}`, {
      method: "GET",
      mode: "cors",
      headers: {
        "Content-Type": "application/json",
      },
    });
    return resp.json();
  } catch (err) {
    console.error(err);
  }
};

export const getAllPurposesCandidate = async () => {
  try {
    const resp = await fetch(`${process.env.REACT_APP_API}/purpose/`, {
      method: "GET",
      mode: "cors",
      headers: {
        "Content-Type": "application/json",
      },
    });
    return resp.json();
  } catch (err) {
    console.error(err);
  }
};

export const patchPurposeCandidate = async (data, candidateId) => {
  try {
    const resp = await fetch(`${process.env.REACT_APP_API}/ta/candidates/purpose/${candidateId}`, {
      method: "PATCH",
      mode: "cors",
      headers: {
        "Content-type": "application/json",
      },
      body: JSON.stringify(data),
    });
    return resp;
  } catch (err) {
    console.error(err);
  }
};

// export const deletePurpose = async (list, candidateId) => {
//   try {
//     const resp = await fetch(`${process.env.REACT_APP_API}ta/candidates/purpose/${candidateId}`, {
//       method: 'DELETE',
//       headers: {
//         'Content-type': 'application/json',
//       },
//       body: JSON.stringify(list),
//     });
//     return resp.json();
//   } catch (err) {
//     console.error(err);
//   }
// };
